import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import { IconButton } from '../../legacy/components';
export const PrintIcon = ({ title, text, size, color, disabled, }) => {
    const theme = useTheme();
    function handlePrint() {
        const printWindow = window.open('', '_blank');
        printWindow?.document.write(`<html style="color: ${theme.palette.primary.dark}; white-space: pre-line">
        <head>
          <title>Print</title>
          <h2 style="font-weight: 200">${title}<h2/>
          <br/>
          <p style="font-size: 16px; font-weight: 200">${text}<p/>
          <style>@media print 
            {
              body * { 
                visibility: visible; font-family: ${theme.typography.fontFamily}
              } 
              #printableContent, #printableContent * { 
                visbility: visible; font-family: ${theme.typography.fontFamily}
              } 
              #printableContent { 
                position: absolute; left: 0; top: 0; font-family: ${theme.typography.fontFamily} 
              } 
            } 
          </style>
        </head>
      </html>`);
        printWindow?.document.close();
        printWindow?.print();
    }
    return (_jsx(IconButton, { disabled: disabled, color: color, size: size, variant: "printer-outline", onClick: handlePrint }));
};
